import React from 'react';

const NutrientElement = ({ color = '#F0EAD2', symbol, name, className }) => {
  const textStyles = {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    fill: '#001C0E',
  };
  return (
    <svg
      viewBox="0 0 56 56"
      width="56"
      height="56"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        rx="6"
        ry="6"
        style={{ fill: color }}
      />
      <text
        x="50%"
        y="35"
        textAnchor="middle"
        className="symbol"
        style={{ ...textStyles, fontSize: '3.1rem' }}
      >
        {symbol}
      </text>
      <text
        x="50%"
        y="48"
        textAnchor="middle"
        className="name"
        style={{
          ...textStyles,
          fontSize: '0.6rem',
          textTransform: 'uppercase',
        }}
      >
        {name}
      </text>
    </svg>
  );
};

export default NutrientElement;
